var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rootElem",staticClass:"nav-collapsible",class:( _obj = {
    'nav-collapsible--open': _vm.open
  }, _obj[("nav-collapsible--" + _vm.variant)] = _vm.variant, _obj )},[_c('div',{staticClass:"nav-collapsible__action"},[_vm._t("action",null,{"toggle":_vm.toggle,"open":_vm.open})],2),_c('div',{ref:"navCollapsibleContent",staticClass:"nav-collapsible__content",attrs:{"aria-hidden":_vm.open ? 'false' : 'true'}},[_vm._t("content",null,{"open":_vm.open})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }